import { PushNotifications } from '@capacitor/push-notifications'
import { Badge } from '@capawesome/capacitor-badge'

import { App } from '@/core/native'

/**
 * get current badge number
 */
export const getBadgeCount = async (): Promise<number> => {
  const result = await Badge.get()
  return result.count || 0
}

/**
 * ネイティブのバッジ数を count の数に変更する
 * countが0以下ならクリアする
 * @param {number} count
 */
export const setBadgeCount = async (count?: number) => {
  const isWeb = App.getPlatform() === 'web'
  if (isWeb) return

  if (typeof count === 'number' && count <= 0) {
    await clearBadgeCount()
    await PushNotifications.removeAllDeliveredNotifications()

    return
  }

  if (!count) return

  await Badge.set({ count })
}

/**
 * clear badge number
 */
export const clearBadgeCount = async () => {
  await Badge.clear()
}

/**
 * request permissions
 * @return Promise<boolean>
 */
export const requestBadgePermissions = async (): Promise<boolean> => {
  const { isSupported } = await Badge.isSupported()
  if (!isSupported) return false

  const permissionStatus = await Badge.checkPermissions()
  if (permissionStatus.display === 'granted') {
    return true
  }

  const result = await Badge.requestPermissions()
  return result.display === 'granted'
}
